import { useState } from "react";
import { CalendarDays, Truck } from "lucide-react";
import DeliveryTour from "@/components/admin/DeliveryTour";
import DeliveryAgenda from "@/components/admin/DeliveryAgenda";

export default function AdminDeliveries() {
  const [tab, setTab] = useState("tour");
  const cls = (a) => `flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium transition-colors ${a ? "bg-amber-deep text-white" : "border border-amber-800/20 bg-white text-bark-soft hover:text-amber-deep"}`;
  return (
    <div data-testid="admin-deliveries" className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl font-semibold text-bark">Tournées de livraison</h1>
        <p className="mt-1 text-sm text-bark-soft">Créneaux proposés aux clients des secteurs livrés sur rendez-vous, et feuille de route du jour.</p>
      </div>
      <div className="flex flex-wrap gap-2">
        <button data-testid="deliveries-tab-tour" onClick={() => setTab("tour")} className={cls(tab === "tour")}><Truck size={15} /> Tournée du jour</button>
        <button data-testid="deliveries-tab-agenda" onClick={() => setTab("agenda")} className={cls(tab === "agenda")}><CalendarDays size={15} /> Agenda des créneaux</button>
      </div>
      {tab === "tour" ? <DeliveryTour /> : <DeliveryAgenda />}
    </div>
  );
}
